var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrennerObenGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5442.52 743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#F6F5F9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5348.82,233.85q-93.7,73.5-265.28,73.51H2973.63q-98,0-160.31,25.17t-92.06,78.57q-29.78-53.4-92.06-78.57t-160.37-25.17H349.54q-171.59,0-265.3-73.51C21.78,184.85,0,106.9,0,0V743H5442.52V0Q5442.52,160.35,5348.82,233.85Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrennerObenGrey);
export default __webpack_public_path__ + "static/media/TrennerObenGrey.10e1bdf567b33db43ec17b41bca43858.svg";
export { ForwardRef as ReactComponent };